import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const AdsProfitCalculatorPage = lazy(
  () => import("../../pages/AdsProfitCalculatorPage")
);

const SamplesFulfillmentPage = lazy(
  () => import("../../workspace/gb/samples-fulfillment")
);

export function GeoffBeresfordRoutes() {
  return (
    <Switch>
      <Route
        path="/gb/ads-profit-calculator"
        component={AdsProfitCalculatorPage}
      />
      <Route
        path="/gb/samples-fulfillment"
        component={SamplesFulfillmentPage}
      />
    </Switch>
  );
}

export const slug = "gb";
